<template>
  <cb-notification-bar
    variant="warning"
    test-id="user-not-connected-to-m365-warning-banner"
    :showCloseButton="false"
  >
    <template #title>
      {{ t("banner-title-account-not-protected") }}
    </template>
    <template #description>
      {{ t("banner-text-connect-m365-account") }}
    </template>
    <template #primaryCta v-if="!isOnConnectionPage">
      <cl-button
        variant="secondary"
        size="small"
        @on-click="goToConnectionPage"
      >
        {{ t("button-add-connection") }}
      </cl-button>
    </template>
  </cb-notification-bar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useIsConnectionsV2Available } from "@/composables/useFlags/useIsConnectionsV2Available";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { isConnectionsV2Available } = useIsConnectionsV2Available();

const connectionPageName = computed(() =>
  isConnectionsV2Available.value
    ? "customer-settings-connections-v2"
    : "customer-settings-connections",
);

const isOnConnectionPage = computed<boolean>(() => {
  return route.name === connectionPageName.value;
});

const goToConnectionPage = (): void => {
  router.push({ name: connectionPageName.value });
};
</script>
